// extracted by mini-css-extract-plugin
export default {"container":"ProjectGallery_container__MENoj","item":"ProjectGallery_item__kDjdP"};